// extracted by mini-css-extract-plugin
export default {"createClosingWorkOrderChangeBody":"CreateClosingWorkOrderChange_createClosingWorkOrderChangeBody__b0QE-"};